import { Component, Input } from "@angular/core";
import { ProductAttributes } from "@models/product.model";

@Component({
    selector: "app-best-sellers-section",
    templateUrl: "./best-sellers-section.component.html",
    styleUrl: "./best-sellers-section.component.scss",
    standalone: false,
})
export class BestSellersSectionComponent {
    @Input() bestSellerProducts: ProductAttributes[] = [];
}
